import { LeaseRepaidTable } from './LeaseRepaidTable'

export default LeaseRepaidTable
